import { createSelector } from '@reduxjs/toolkit';

import { selectVideo } from './videoPlayer';

export const selectVideoProperties = createSelector(
  selectVideo,
  video => video.video_properties
);

export const selectVideoWidth = createSelector(
  selectVideo,
  video => video.video_properties.width
);

export const selectVideoHeight = createSelector(
  selectVideo,
  video => video.video_properties.height
);

export const selectCommentsEnabled = createSelector(
  selectVideo,
  video => video.comments_enabled
);

export const selectRecordReplyEnabled = createSelector(
  selectVideo,
  video => video.record_reply_enabled
);

export const selectEmojiEnabled = createSelector(
  selectVideo,
  video => video.use_emojis
);

export const selectCommentsOrEmojiEnabled = createSelector(
  selectCommentsEnabled,
  selectEmojiEnabled,
  (commentsEnabled, emojiEnabled) => commentsEnabled || emojiEnabled
);

export const selectOwnerName = createSelector(
  selectVideo,
  video => video.owner_name
);

export const selectVideoId = createSelector(selectVideo, video => video.id);

export const selectVideoS3Id = createSelector(
  selectVideo,
  video => video.s3_id
);

export const selectVideoWaveformStatus = createSelector(
  selectVideo,
  video => video.waveform_generation
);

export const selectVideoWaveformUrl = createSelector(
  selectVideo,
  video => video.waveform_url
);

export const selectVideoHasAudioEnabled = createSelector(
  selectVideoProperties,
  videoProperties =>
    videoProperties.microphone_enabled || videoProperties.recordInternalAudio
);

export const selectVideoProcessingInformation = createSelector(
  selectVideo,
  video => video.processing_information
);

export const selectVideoTrimRanges = createSelector(
  selectVideoProcessingInformation,
  info => info.trim_ranges || []
);
